// extracted by mini-css-extract-plugin
export default {"innerWrapper":"welcome-text-module--innerWrapper--bb2ba","textStart":"welcome-text-module--textStart--39a41","topLogo":"welcome-text-module--topLogo--68470"};